import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';
import { WindowRef } from 'src/app/Window/WindowRef';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import {NgxGalleryOptions, NgxGalleryAction} from '@kolkov/ngx-gallery';
import {NgxGalleryImage} from '@kolkov/ngx-gallery';
import {NgxGalleryAnimation} from '@kolkov/ngx-gallery';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditProperyTypeComponent } from '../components/edit-propery-type/edit-propery-type.component';
import { EditLocationInfoComponent } from '../components/edit-location-info/edit-location-info.component';
import { EditPropertyFacilitiesComponent } from '../components/edit-property-facilities/edit-property-facilities.component';
import { EditPropertyImagesComponent } from '../components/edit-property-images/edit-property-images.component';
import { isPlatformBrowser } from '@angular/common';
import { ImagePreviewComponent } from '../components/image-preview/image-preview.component';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { BankPaymentComponent } from '../components/bank-payment/bank-payment.component';
import { EditPropertyPaymentComponent } from '../components/edit-property-payment/edit-property-payment.component';
import { BankTransferComponent } from '../components/bank-transfer/bank-transfer.component';

@Component({
  selector: 'app-edit-property',
  templateUrl: './edit-property.component.html',
  styleUrls: ['./edit-property.component.css']
})
export class EditPropertyComponent implements OnInit{


  map: google.maps.Map;

  coordinates: any

  mapOptions: google.maps.MapOptions

  marker: any

  longitude: any = '85.30328010000001'

  latitude: any = '27.6697302'

  autocomplete: any

  provinceList = []

  districtList = []

  municipalityList = []

  validMunicipalityList = []

  validDistrictList = []

  selectedUnitDistance: string ="Meter"

  selectedUnitHouse: string = 'Square Meter'

  selectedUnitTotal: string = 'Square Meter'

  options = {
    componentRestrictions: {country: 'np'}
  };

  loaded: boolean

  propertyId: any

  property: any

  propertyInfo: any

  propertyTypes = []

  adId: any

  url: string


  address: any

  seller: Observable<any>

  galleryOptions: NgxGalleryOptions[]

  galleryImages: NgxGalleryImage[] = []

  otherFacilities = []

  @ViewChild('mapContainer', {static: false}) gmap: ElementRef;

  similarProperties = []

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/colony.jpg'})`+` no-repeat center center`)

  loggedIn: boolean 

  notFavourite: boolean = true

  favourite: any

  bankPayment: any

  transaction: any

  mapLoaded: boolean

  galleryAction = <NgxGalleryAction>{
    icon: 'fas fa-trash',
    onClick: this.deleteImage
  }

  adPlans = []

  propertyImages = []

  seoData: SeoSocialShareData = {
    title:  'Edit Property',
    description: 'Advertisements are modified to suit the need.',
    image: environment.url+'/assets/logo.png'
  };

  constructor(private route: ActivatedRoute, private _neproseService: NeproseService, @Inject(PLATFORM_ID) protected platformId: Object, private window: WindowRef,
  private _sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private _authService: AuthService, private dialog: MatDialog, private _notification: MatSnackBar,
  private seo: SeoSocialShareService, private _ngZone: NgZone) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.adId = this.route.snapshot.params.id
    this.route.data.subscribe((data: { provinceList: any, districtList: any, municipalityList: any, propertyAd: any, propertyTypes: any, adPlans: any }) =>{
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities
      this.property = data.propertyAd.propertyAd
      this.propertyTypes = data.propertyTypes
      this.adPlans = data.adPlans
    })
    this.url = environment.url + '/advertisement/' + this.adId
    this.galleryOptions = [
      {
        width: '100%',
        height: '500px',
        thumbnailsColumns: 4,
        arrowPrevIcon: 'fa fa-chevron-left',
        arrowNextIcon: 'fa fa-chevron-right',
        imageAnimation: NgxGalleryAnimation.Slide,
        thumbnailActions: [{icon: 'fas fa-trash', onClick: this.deleteImage.bind(this), titleText: 'delete'}]
      },
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      {
        breakpoint: 400,
        preview: false
      }
    ];
    if(this.property.status == 'requested' || this.property.status == 'completed'){
      this.getBankPayment()
    }
  }

  getBankPayment(){
    this._neproseService.getBankPayment(this.property.aliasId).subscribe(data => {
      if(data.status){
        let payment = data.bankPayment
        payment['image'] = environment.api + '/images/' + payment['voucherPath']
        let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
        if(adPlan){
          payment['plan'] = adPlan.plan
          payment['amount'] = adPlan.price
        }
        this.bankPayment = payment
      }
    }, error => {
      if(error.status == 404){
        this.getBankTransaction()
      }
    })
  }

  deletePayment(id){
    this._neproseService.deleteBankPayment(id).subscribe(data => {
      if(data.status){
        this.bankPayment = null
        this.openNotification('Payment info has been removed!')
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

  deleteTransaction(id){
    this._neproseService.deleteTransaction(id).subscribe(data => {
      if(data.status){
        this.transaction = null
        this.openNotification('Transaction info has been removed!')
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

  getBankTransaction(){
    this._neproseService.getTransaction(this.property.aliasId).subscribe(data => {
      if(data.status){
        let payment = data.transaction
        if(payment['voucherPath']) payment['image'] = environment.api + '/images/' + payment['voucherPath']
        let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
        if(adPlan){
          payment['plan'] = adPlan.plan
          payment['amount'] = adPlan.price
        }
        this.transaction = payment
      }
    })
  }

  ngAfterViewInit(){
    this.prepareAdvertisement()
    this.cdr.detectChanges()
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.mapInitializer()
        this.cdr.detectChanges()
      }, 2000)
    })
  }

  mapInitializer() {
    if(isPlatformBrowser(this.platformId)){
      this.coordinates  = new google.maps.LatLng(this.property.latitude, this.property.longitude)
      this.mapOptions = {
          center: this.coordinates,
          zoom: 14
      }
      this.marker = new google.maps.Marker({
          position: this.coordinates,
          map: this.map,
      })
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions)
      this.marker.setMap(this.map)
      this.mapLoaded = true
    }  
  }

  prepareAdvertisement(){
    let district = this.districtList.find(district => district.id == this.property.district_id)
    let municipality = this.municipalityList.find(municipality => municipality.id == this.property.municipality_id)
    this.address = municipality.municipality+', '+district.district
    if(this.property.village){
      this.address = this.property.village+', '+this.address
    }
    if(this.property.otherFacilities){
      this.otherFacilities = JSON.parse(this.property.otherFacilities)
    }
    if(this.property.PropertyImage){
      this.propertyImages = JSON.parse(this.property.PropertyImage.imagePath)
      if(this.propertyImages.length > 0){
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+this.propertyImages[0]})`+` no-repeat center center`)
        for(let image of this.propertyImages){
          this.galleryImages.push(
            {
              small: environment.api+'/images/'+image,
              medium: environment.api+'/images/'+image,
              big: environment.api+'/images/'+image,
              label: image
            }
          )
        }
      }
    }
  
    this.property['availableFrom'] = new Date(this.property.createdAt).toDateString()
    this.loaded = true
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }


  editBasicInfo(){
    const dialogRef = this.dialog.open(EditProperyTypeComponent, {
      width: '80%',
      data: {
        iam: this.property.iam,
        listingFor: this.property.listingFor,
        property_type_id: this.property.property_type_id,
        distFromRoad: this.property.distFromRoad,
        totalArea: this.property.totalArea,
        houseArea: this.property.houseArea,
        floor: this.property.floor,
        price: this.property.price,
        propertyTypes: this.propertyTypes
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.updateProperty(result)
      }
    });
  }

  editLocationInfo(){
    const dialogRef = this.dialog.open(EditLocationInfoComponent, {
      width: '80%',
      data: {
        municipality_id: this.property.municipality_id,
        latitude: this.property.latitude,
        longitude: this.property.longitude,
        province_id: this.property.province_id,
        district_id: this.property.district_id,
        wardNumber: this.property.wardNumber,
        village: this.property.village,
        provinceList: this.provinceList,
        municipalityList: this.municipalityList,
        districtList: this.districtList
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.updateProperty(result)
      }
    });
  }

  editOtherFacilities(){
    const dialogRef = this.dialog.open(EditPropertyFacilitiesComponent, {
      width: '80%',
      data: {
        title: this.property.title,
        details: this.property.details,
        parking: this.property.parking,
        waterSupply: this.property.waterSupply,
        electricity: this.property.electricity,
        telecommunication: this.property.telecommunication,
        gasSupply: this.property.gasSupply,
        otherFacilities: this.property.otherFacilities
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.updateProperty(result)
      }
    });
  }

  updateBankPayment(){
    let dialogRef = this.dialog.open(BankPaymentComponent, {
      width: '70%',
      data: {
        property_id: this.bankPayment.property_id,
        voucherPath: this.bankPayment.voucherPath,
        remarks: this.bankPayment.remarks,
        image: this.bankPayment.image
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._neproseService.updateBankPayment(this.bankPayment.id, result).subscribe(data => {
          if(data.status){
            let payment = data.bankPayment
            payment['image'] = environment.api + '/images/' + payment['voucherPath']
            let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
            if(adPlan){
              payment['plan'] = adPlan.plan
              payment['amount'] = adPlan.price
            }
            this.bankPayment = payment
            this.openNotification('Payment info has been updated!')
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  updateTransaction(){
    let dialogRef = this.dialog.open(BankTransferComponent, {
      width: '70%',
      data: {
        paymentMethod: this.transaction.paymentMethod,
        property_id: this.transaction.property_id,
        transaction_id: this.transaction.transaction_id,
        amount: this.transaction.amount,
        adPlans: this.adPlans,
        currentAdPlan: this.property.ad_plan_id
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._authService.updatePaymentDetails(this.transaction.id, result).subscribe(data => {
          if(data.status){
            // let payment = data.checkTransaction
            // let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
            // if(adPlan){
            //   payment['plan'] = adPlan.plan
            // }
            // this.transaction = payment
            // this.openNotification('Transaction info has been updated!')
          }
        }, error => {
          if(error.error.message){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  editPaymentInfo(){
    let paymentInfo = null
    if(this.bankPayment){
      paymentInfo = {
        property_id: this.bankPayment.property_id,
        voucherPath: this.bankPayment.voucherPath,
        remarks: this.bankPayment.remarks,
        image: this.bankPayment.image,
        paymentMethod: null,
        transaction_id: null
      }
    }else if(this.transaction){
      paymentInfo = {
        property_id: this.transaction.property_id,
        voucherPath: this.transaction.voucherPath,
        remarks: null,
        image: this.transaction.image,
        paymentMethod: this.transaction.paymentMethod,
        transaction_id: this.transaction.transaction_id
      }
    }
    console.log(paymentInfo)
    let dialogRef = this.dialog.open(EditPropertyPaymentComponent, {
      width: '70%',
      data: paymentInfo
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result['selectedPayment'] == 'bankPayment'){
          if(this.bankPayment){
            delete result['selectedPayment']
            this._neproseService.updateBankPayment(this.bankPayment.id, result).subscribe(data => {
              if(data.status){
                let payment = data.bankPayment
                payment['image'] = environment.api + '/images/' + payment['voucherPath']
                let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
                if(adPlan){
                  payment['plan'] = adPlan.plan
                  payment['amount'] = adPlan.price
                }
                this.bankPayment = payment
                this.transaction = null
                this.openNotification('Payment info has been updated!')
              }
            }, error => {
              if(error.error.message){
                this.openNotification(error.error.message)
              }
            })
          }else{
            this._neproseService.deleteTransaction(this.transaction.id).subscribe(data => {
              if(data.status){
                this.transaction = null
                delete result['selectedPayment']
                this._neproseService.addBankPayment(result).subscribe(data => {
                  if(data.status){
                    let payment = data.bankPayment
                    payment['image'] = environment.api + '/images/' + payment['voucherPath']
                    let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
                    if(adPlan){
                      payment['plan'] = adPlan.plan
                      payment['amount'] = adPlan.price
                    }
                    this.bankPayment = payment
                    this.openNotification('Payment info has been updated!')
                  }
                }, error => {
                  if(error.error.message){
                    this.openNotification(error.error.message)
                  }
                })
              }
            }, error => {
              if(error.error.message){
                this.openNotification(error.error.message)
              }
            })
          }
        }else if(result['selectedPayment'] == 'transaction'){
          if(this.transaction){
            delete result['selectedPayment']
            result['amount'] = this.transaction.amount
            this._authService.updatePaymentDetails(this.transaction.id, result).subscribe(data => {
              let payment = data.transaction
              if(payment['voucherPath']) payment['image'] = environment.api + '/images/' + payment['voucherPath']
              let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
              if(adPlan){
                payment['plan'] = adPlan.plan
                payment['amount'] = adPlan.price
              }
              this.transaction = payment
              this.bankPayment = null
              this.openNotification('Payment Info has been updated!')
            }, error => {
              if(error.error.message){
                this.openNotification(error.error.message)
              }
            })
          }else{
            delete result['selectedPayment']
            let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
            if(adPlan){
              result['amount'] = adPlan.price
            }
            this._neproseService.deleteBankPayment(this.bankPayment.id).subscribe(data => {
              if(data.status){
                this.bankPayment = null
                this._authService.savePaymentDetails(result).subscribe(data => {
                  if(data.status){
                    let payment = data.transaction
                    if(payment['voucherPath']) payment['image'] = environment.api + '/images/' + payment['voucherPath']
                    let adPlan = this.adPlans.find(adPlan => adPlan.id == this.property.ad_plan_id)
                    if(adPlan){
                      payment['plan'] = adPlan.plan
                      payment['amount'] = adPlan.price
                    }
                    this.transaction = payment
                    this.openNotification('Payment Info has been updated!')
                  }
                }, error => {
                  if(error.error.message){
                    this.openNotification(error.error.message)
                  }
                })
              }
            }, error => {
              if(error.error.message){
                this.openNotification(error.error.message)
              }
            })
          }
        }
        
      }
    })
  }

  previewImage(imagePath){
    const dialogRef = this.dialog.open(ImagePreviewComponent,{
      maxWidth: '90%',
      maxHeight: '90%',
      panelClass: 'image-preview',
      data: {
        imageSource: imagePath
      }
    });
  }

  updateImages(){
    const dialogRef = this.dialog.open(EditPropertyImagesComponent, {
      width: '80%',
      data: {
        images: []
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result.images){
          this._neproseService.changePropertyImage(this.property.id, result.images).subscribe(data => {
            if(data.status){
              this.openNotification(data.message)
              let propertyImages = JSON.parse(data.propertyImages.imagePath)
              if(propertyImages.length > 0){
                this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+propertyImages[0]})`+` no-repeat center center`)
                this.galleryImages = []
                for(let image of propertyImages){
                  this.galleryImages.push(
                    {
                      small: environment.api+'/images/'+image,
                      medium: environment.api+'/images/'+image,
                      big: environment.api+'/images/'+image,
                      label: image
                    }
                  )
                  this.propertyImages = propertyImages
                }
              }
            }
          }, error => {
            if(error.error){
              if(error.error.message){
                this.openNotification(error.error.message)
              }
            }
          })
        }
      }
    });
  }

  deleteImage(event, i){
    let imageObj = this.galleryImages[i]
    if(imageObj.label){
      this._neproseService.deletePropertyImage(this.property.id, imageObj.label).subscribe(data => {
        if(data.status){
          this.openNotification(data.message)
          let propertyImages = JSON.parse(data.propertyImages.imagePath)
          this.galleryImages = []
          if(propertyImages.length > 0){
            this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+propertyImages[0]})`+` no-repeat center center`)
            for(let image of propertyImages){
              this.galleryImages.push(
                {
                  small: environment.api+'/images/'+image,
                  medium: environment.api+'/images/'+image,
                  big: environment.api+'/images/'+image,
                  label: image
                }
              )
              this.propertyImages = propertyImages
            }
          }else{
            this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/colony.jpg'})`+` no-repeat center center`)
          }
        }
      }, error => {
        if(error.error.message){
          this.openNotification(error.error.message)
        }
      })
    }
  }

  updateProperty(result){
    let property = Object.assign({},this.property)
    delete property['PropertyImage']
    delete property ['PropertyType']
    delete property['approvalDate']
    delete property['createdAt']
    delete property['updatedAt']
    delete property['availableFrom']
    // delete property['ad_plan_id']
    delete property['user_id']
    delete property['status']
    delete property['id']
    // delete property['listingFor']
    delete property['title_np']
    delete property['totalView']
    delete property['aliasId']
    for(let key in result){
      property[key] = result[key]
    }
    this._neproseService.updateProperty(this.property.id, property).subscribe(data => {
      if(data.status){
        this.openNotification(data.message)
        this.property = data.propertyAd
        this.prepareAdvertisement()
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }else if(error.error.error){
        this.openNotification(error.error.error)
      }
    })
  }

}
